"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Logo", {
  enumerable: true,
  get: function get() {
    return _Logo.Logo;
  }
});
var _Logo = require("./Logo");